<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div class="view">
	<div>
		<div class="display-label">First Name</div>
		<div class="display-value">{{ viewModel?.dataModel?.firstName }}</div>
	</div>
	<div>
		<div class="display-label">Last Name</div>
		<div *ngIf="!viewModel?.dataModel?.hasCustomerId" class="display-value">{{ viewModel?.dataModel?.lastName }}</div>
		<a *ngIf="viewModel?.dataModel?.hasCustomerId" [routerLink]="['/customers', viewModel?.dataModel?.customerId]">{{ viewModel?.dataModel?.lastName }}</a>
	</div>
	<div>
		<div class="display-label">Email</div>
		<div class="display-value">{{ viewModel?.dataModel?.email }}</div>
	</div>
	<div>
		<div class="display-label">Phone</div>
		<div class="display-value">{{ viewModel?.dataModel?.phoneNumber }}</div>
	</div>
	<div class="full">
		<div class="display-label">Delivery Address</div>
		<div class="display-value addr" [innerHTML]="viewModel?.dataModel?.address"></div>
	</div>
	<div class="full">
		<div class="display-label">Event Contact Preferences</div>
		<div class="display-value">{{ viewModel?.dataModel?.organiserContactPreferenceDisplay }}</div>
	</div>
	<div class="full">
		<div class="display-label">Orbit Contact Preferences</div>
		<div class="display-value">{{ viewModel?.dataModel?.orbitContactPreferenceDisplay }}</div>
	</div>
</div>
